<template>
<div class="pop-up">
   <el-form :model="form" :rules="rules" ref="form" label-width="100px">
       <el-form-item label="图书证号：" prop="className" v-if="showlibraryregistration">
        <div style="display:flex ; align-items: center; margin-bottom: 10px;">
            <img :src="showlibraryregistrationinfo" alt="" style="width: 150px;height: 150px; ">   
            <span style="margin-left:10px ;">(请先扫码注册图书证号，填入下方输入框)</span>
        </div>
        <Input v-model="form.registration" type="text" placeholder="请填写图书证号"></Input>
       </el-form-item>
        <el-form-item label="真实姓名：" prop="userName">
            <Input v-model="form.userName" type="text"></Input>
        </el-form-item>
        <el-form-item label="手机号码：" prop="tel">
            <Input v-model="form.tel" type="text"></Input>
        </el-form-item>
        <el-form-item :label="text+'：'" prop="department">
            <Input v-model="form.department" type="text" :placeholder="tishi"></Input>
        </el-form-item>
        <el-form-item :label="text2+'：'" prop="className">
            <Input v-model="form.className" type="text" :placeholder="tishi2"></Input>
        </el-form-item>
        
   </el-form>
   <div class="btn_box" style="text-align:center;">
        <!-- <el-button class="btn_add_canle" @click="close()">取 消</el-button>  -->
        <el-button class="btn_add_sure" @click="submit()" type="primary">提 交</el-button>
   </div>
</div> 
</template>
<script>
import { Form, FormItem, Input, Button} from 'element-ui'
  import Cookies from 'js-cookie'
  import { editPersonInfo, userList, } from '@/api/manage.js'
  import {  showindependently } from '@/api/pages'
export default {
    name: 'ImproveInfo',
    props: [],
    data(){
        let text = JSON.parse(localStorage.getItem('user')).libType == '公共馆' ? '行业' : '院系',
            text2 = JSON.parse(localStorage.getItem('user')).libType == '公共馆' ? '区域' : '班级';
        let checkUserName = (rule, value, callback) => {
            if(value=='自主注册用户'){
                return callback(new Error('请输入真实姓名！'));
            }else{
                return callback();
            }
        };
        return {
            text: text,
            text2:text2,
            tishi: JSON.parse(localStorage.getItem('user')).libType == '公共馆' ? '如：互联网' : '如：计算机系',
            tishi2: JSON.parse(localStorage.getItem('user')).libType == '公共馆' ? '如：朝阳区' : '如：23级软件1班',
            form:{
                userId: JSON.parse(localStorage.getItem('user')).gid,
                registration:'',
                userName:'',
                tel:'',
                department:'',
                className:''
            },
            showlibraryregistration:false,
            showlibraryregistrationinfo:'',
            rules:{
                registration:[
                { required: true, message: '请输入注册结果', trigger: 'blur' },
                ],
                userName: [
                    { required: true, message: '请输入真实姓名', trigger: 'blur' },
                    { validator: checkUserName, trigger: 'blur'  }
                ],
                tel: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
                ],
                department: [
                    { required: true, message: '请输入'+text+'...', trigger: 'blur' }
                ],    
                className: [
                    { required: true, message: '请输入'+text2+'...', trigger: 'blur' }
                ],             
            }
        }
    },
    watch:{
        
    },
    components: {Form, FormItem, Input, Button},
    mounted(){
        this.getPersonInfo();//回显用户信息
        this.libraryregistration()   // 是否需要先在学校注册
    },  
    methods: {
        close(){//默认关闭事件
            this.$emit('close');
        },
        getPersonInfo(){
            let vm = this;
            userList({
                userId: JSON.parse(localStorage.getItem('user')).gid
            }).then(res => {
                if(res.status){
                    vm.form.userName = res.data.list[0].userName;
                    vm.form.tel = res.data.list[0].tel;
                    vm.form.department = res.data.list[0].department;
                    vm.form.className = res.data.list[0].className;
                    vm.form.registration = res.data.list[0].registration;
                }
            }).catch(err => {

            });
        },
        async libraryregistration(){
            let data = { orgGid: JSON.parse(localStorage.getItem('user')).orgGid };
            let res = await showindependently(data)
            if (res.code == '200') {
            this.showlibraryregistration = res.data.data.istsgqrcode
            if(this.showlibraryregistration){
                this.showlibraryregistrationinfo = res.data.data.tsgqrcode
            }
            } else {
             this.$message({
             message: res.msg,
             type: "error",
             duration: 5 * 1000
          });
        }
        },
        submit(){
            let vm = this;
            // 表单验证
            vm.$refs.form.validate((valid,obj) => {
                if(valid){
                    vm.isDisabled = true;
                    editPersonInfo(vm.form).then(res => {
                        if(res.status){
                            let user = JSON.parse(localStorage.getItem('user'));
                            user.userName = vm.form.userName;
                            user.tel = vm.form.tel;
                            localStorage.setItem('user', JSON.stringify(user));
                            Cookies.set("name", vm.form.userName);
                            vm.$message({message: '修改成功！',type: 'success'});
                            vm.$emit('submit', vm.form.userName);
                        }else{
                            vm.$message({message: res.errorMsg || '修改失败！',type: 'error'});
                        }
                    }).catch(res => {
                        vm.isDisabled = false;
                        vm.$message({message: res.res.errorMsg || '修改失败',type: 'error'});
                    });
                }else{
                    return false;
                }
            });
        }
    }
}
</script>
<style lang = "scss" scoped>
</style>





// WEBPACK FOOTER //
// src/components/improveInfo.vue